<template>
  <el-dialog
    :visible="isTimeSettingVisible"
    class="timing"
    :modal-append-to-body="false"
    @close="onCancel"
  >
    <div class="time_box">
      <i
        class="el-icon-close text-button"
        @click="onCancel"
      />
      <div class="blue_border">
        {{ $t('iftttset.timingset') }}
      </div>
      <div class="row-container">
        <!-- <div class="row">
          <p>类型</p>
          <div class="row-main">
            <el-radio-group v-model="type">
              <el-radio v-for="(item, i) of typeList" :key="i" :label="item.value">
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </div>
        </div> -->
        <div v-if="type === 1" class="row">
          <p>{{ $t('iftttset.timeSetting') }}</p>
          <div class="row-main">
            <el-time-picker
              v-model="timeValueCopy"
              :editable="true"
              class="timedata"
              format="HH:mm"
              value-format="HH:mm"
            />
          </div>
        </div>
      </div>
      
      
      <span
        slot="footer"
        class="dialog-footer"
      >
        <button
          class="blueButton"
          type="primary"
          @click="onOk"
        >
          {{ $t('iftttset.sure') }}
        </button>
        <button
          class="lightButton"
          @click="onCancel"
        >
          {{ $t('iftttset.cancle') }}
        </button>
      </span>
    </div>
  </el-dialog>
</template>
<script>

export default {
  components: {
  },
  props: {
    isTimeSettingVisible: {
      type: Boolean,
      default: false,
    },
    timeValue: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      type: 1,
      typeList: [
        {
          name: this.$t('ifttt.time'),
          value: 1
        }
      ],
      timeValueCopy:''
    }
  },

  computed: {},

  watch: {
    timeValue: {
      handler(newValue) {
        this.timeValueCopy = newValue
      },
      immediate: true
    }
  },

  mounted() {
  },

  created() {},
  beforeDestroy() {
  },

  methods: {
    onOk() {
      this.$emit('onOk', this.timeValueCopy);
      // this.triggleTimeAdd();
      // this.hidenTimeSetting();
    },

    triggleTimeAdd() {

    },

    onCancel() {
      this.$emit('onCancel');
    },

    hidenTimeSetting() {

    }
  },
}
</script>

<style lang="scss" scoped>
.row-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 40px auto;
}

.row {
  display: flex;
  align-items: center;
  width: 500px;
  margin-bottom: 10px;

  p {
    min-width: 80px;
    margin-right: 10px;
  }

  .timedata {
    margin: 0;
  }
}
</style>
